module.exports = "/_next/static/images/banner-4d8809d607c4afec1e5687d23b980058.jpg";